module.exports = __webpack_public_path__ + "img/contact_service-header.ecb891c1.png";